// extracted by mini-css-extract-plugin
module.exports = {"background":"style-module--background--2QmDb","content":"style-module--content--2UdrB","info":"style-module--info--2oaT9"};